export const hasTabIndex = (element: Element) =>
  element.hasAttribute('tabindex')

export const hasNegativeTabIndex = (element: HTMLElement) =>
  hasTabIndex(element) && element.tabIndex < 0
